const DEV_PORT = 9519;
const PROD_PORT = 8519;
const API_BASE = `https://foreign-analysis.edifier.com:${PROD_PORT}`;
// const API_BASE = 'http://localhost:3000';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.discord-member-coupon');
  if (!root) return;

  const settingsEl = document.getElementById(`DiscordMemberCouponSettings-${root.dataset.sectionId}`);
  const settings = settingsEl ? JSON.parse(settingsEl.textContent) : {};

  const unauthorizedView = root.querySelector('#unauthorized-view');
  const authorizedView = root.querySelector('#authorized-view');
  const loginBtn = root.querySelector('#login-btn');
  const modal = document.getElementById('discord-member-coupon-modal');

  fetchStatus();

  function fetchStatus() {
    fetch(`${API_BASE}/api/user/status`, { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        if (!data.authorized) {
          showView(unauthorizedView);
        } else {
          const user = data.user;
          if (user.error === 'not_in_guild') {
            showView(unauthorizedView);
            showModal(settings.modalNotInGuildMessage);
            logout();
          } else if (user.hasRole) {
						renderAuthorizedView(user.username);
            showView(authorizedView);
          } else {
            showView(unauthorizedView);
            showModal(settings.modalNoRoleMessage);
            logout();
          }
        }
      })
      .catch((err) => {
        console.error('Error fetching status:', err);
        showView(unauthorizedView);
      });
  }

  function showView(view) {
    unauthorizedView.classList.add('hidden');
    authorizedView.classList.add('hidden');
    view.classList.remove('hidden');

    const isAuthorized = view === authorizedView;
    root.classList.toggle('authorized', isAuthorized);
    root.classList.toggle('unauthorized', !isAuthorized);
  }

  function renderAuthorizedView(username) {
    const welcomeMessage = (settings.authorizedWelcomeMessage || '').replace(
      '{username}',
      username
    );

    authorizedView.innerHTML = `
      <h5 class="title">${escapeHtml(settings.authorizedTitle)}</h5>
      <p class="desc">${escapeHtml(welcomeMessage)}</p>
			<div class="klaviyo-form-${settings.klaviyoFormId}"></div>
    `;
  }

  function showModal(message) {
    const modalMessage = message || settings.modalDefaultMessage;

    modal.innerHTML = `
      <div class="discord-member-coupon__modal-content">
        <h5 class="title">${escapeHtml(settings.modalTitle)}</h5>
        <p class="desc">${escapeHtml(modalMessage)}</p>
        <a href="${settings.modalLinkUrl}" class="discord-member-coupon__btn discord-member-coupon__btn--link">${escapeHtml(settings.modalLinkText)}</a>
      </div>
    `;

    modal.classList.remove('hidden');
  }

  function hideModal() {
    modal.classList.add('hidden');
  }

  function logout() {
    fetch(`${API_BASE}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    }).then(() => {
      showView(unauthorizedView);
    });
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text ?? '';
    return div.innerHTML;
  }

  loginBtn.addEventListener('click', () => {
    window.location.href = `${API_BASE}/api/auth/discord?return_url=${window.location.origin}`;
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      hideModal();
    }
  });
});
